import SyncableModel from "../../database/SyncableModel"
import { Farm } from "../../database"
import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { getGeneralApiProblem } from "../../services/api/api-problem"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store"
import { BaseModelStoreProps } from "../base-model-store/base-model-store"
import { withBaseModel } from "../extensions/with-base-model"
import JalaAnalytic from "../../utils/jala-analytic"

const FarmStoreProps = {
  ...BaseModelStoreProps
}

/**
 * Model description here for TypeScript hints.
 */
export const FarmStoreModel = types
  .model("FarmStore")
  .props(FarmStoreProps)
  .extend(withRootStore)
  .extend(withEnvironment)
  .extend(withBaseModel)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof FarmStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    init() {
      self.initModel();
    },
    async storeToServer(data) {
      return self.storeModelToServer(Farm, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile app: create farm - currency selected', data)
          return success;
        });
    },
    async store(data) {
      return this.storeToServer(data);
      // return self.storeModel(Farm, data);
    },
    async updateToServer(model: SyncableModel, data) {
      return self.updateModelToServer(Farm, model, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile: Setting Farm - updated', data);
          return success;
        });
    },
    async update(model: SyncableModel, data) {
      return this.updateToServer(model, data);
      // return self.updateModel(Farm, model, data);
    },
    async deleteFromServer(model: SyncableModel) {
      return self.deleteModelFromServer(Farm, model)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile: delete farm', model.toArray());
          return success;
        });
    },
    async delete(model: SyncableModel) {
      return this.deleteFromServer(model);
      // return self.deleteModel(Farm, model);
    },
    async addFarmProfile(data) {
      const { tokenStore: { token } } = self.rootStore;
      this.set('loading', true)

      const result: any = await self.apiSauce.post(`/farms/${data.farmId}/farm_users`, data,
        {
          headers: { Authorization : `Bearer ${token.access_token}` }
        }
      )

      // if (result.status === 200) {
      if (result.status === 201) {
        this.set('error', null)
        this.set('needRefresh', true)
        this.set('loading', false)
      } else {
        __DEV__ && console.warn(result.status)
        this.set('error', getGeneralApiProblem(result))
        this.set('loading', false)
      }
    },
    async updateFarmProfile(data) {
      const { tokenStore: { token } } = self.rootStore;
      this.set('loading', true)

      const result: any = await self.apiSauce.post(`/farms/${data.farm_id}/farm_users/${data.id}`, data.param,
        {
          headers: { Authorization : `Bearer ${token.access_token}` }
        }
      )

      if (result.status === 200) {
        this.set('error', null)
        this.set('needRefresh', true)
        this.set('loading', false)
      } else {
        __DEV__ && console.warn(result.status)
        this.set('error', getGeneralApiProblem(result))
        this.set('loading', false)
      }
    },
    async deleteFarmProfile(data) {
      const { tokenStore: { token } } = self.rootStore;
      this.set('loading', true)

      const result: any = await self.environment.api.apisauce.delete(`/farms/${data.farm_id}/farm_users/${data.id}`, {},
        {
          headers: { Authorization : `Bearer ${token.access_token}` }
        }
      )

      if (result.status === 200) {
        this.set('error', null)
        this.set('needRefresh', true)
        this.set('loading', false)
      } else {
        __DEV__ && console.warn(result.status)
        this.set('error', getGeneralApiProblem(result))
        this.set('loading', false)
      }
    },
    async fetchFrTable() {
      const token = self.rootStore.tokenStore.token.access_token;
      const farmId = self.rootStore.appStore.farmId;
      const result: any = await self.apiSauce.get("/farm_fr_tables", { farm_id: farmId }, {
        headers: {
          Authorization : `Bearer ${token}`
        }
      })
      if (result.status === 200) {
        const { data } = result.data;
        this.set('error', null)
        return data;
        // self.setError(null)
        // self.setCategories(arrCategory)
      } else {
        // return result;
        // __DEV__&& console.tron.log(result.status)
        // self.setCategories(null)
        this.set('error', getGeneralApiProblem(result))
      }
    },
  }))

type FarmStoreType = Instance<typeof FarmStoreModel>
export interface FarmStore extends FarmStoreType {}
type FarmStoreSnapshotType = SnapshotOut<typeof FarmStoreModel>
export interface FarmStoreSnapshot extends FarmStoreSnapshotType {}
export const createFarmStoreDefaultModel = () => types.optional(FarmStoreModel, {})
